import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { HelmetProvider } from "react-helmet-async";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ProductsPage from "@/pages/ProductsPage";
import ContactPage from "@/pages/ContactPage";
import FrozenPulpPage from "@/pages/products/FrozenPulpPage";
import FrozenChunksPage from "@/pages/products/FrozenChunksPage";
import DriedPineapplePage from "@/pages/products/DriedPineapplePage";
import WholeFruitPage from "@/pages/products/WholeFruitPage";

function App() {
  return (
    <HelmetProvider>
      <div className="App font-body">
        <BrowserRouter>
          <ScrollToTop />
          <Navbar />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/products" element={<ProductsPage />} />
            <Route path="/products/frozen-pulp" element={<FrozenPulpPage />} />
            <Route path="/products/frozen-chunks" element={<FrozenChunksPage />} />
            <Route path="/products/dried-pineapple" element={<DriedPineapplePage />} />
            <Route path="/products/whole-fruit" element={<WholeFruitPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
          <Footer />
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </div>
    </HelmetProvider>
  );
}

export default App;
